import { MultiAction } from './admin-multi-select-sidebar.actions';

const customerMultiActions = [
  {
    id: 'downloadCSV',
    label: 'Export data',
    icon: 'file_download',
    className: 'multi-select-sidebar__button--download',
  },
  {
    id: 'createGroup',
    label: 'Create Group',
    svgIcon: 'object-group',
    iconColor: 'accent',
  },
  {
    id: 'manageNetworkstatus',
    label: 'Manage Networkstatus',
    icon: 'network_check',
    iconColor: 'accent',
  },
  {
    id: 'showData',
    label: 'Show data',
    icon: 'table_chart',
    iconColor: 'accent',
  },
  {
    id: 'showOnMap',
    label: 'Show on map',
    icon: 'map',
    iconColor: 'accent',
  },
  {
    id: 'viewDetails',
    label: 'View details',
    icon: 'view_compact_alt',
    iconColor: 'accent',
  },
  {
    id: 'copyIds',
    label: 'Copy IDs to Clipboard',
    icon: 'content_copy',
    iconColor: 'accent',
  },
  {
    id: 'uploadMovebankData',
    label: 'Movebank Data Upload',
    icon: 'cloud_upload',
    iconColor: 'accent',
  },
  {
    id: 'activateMovebankForwarding',
    label: 'Movebank Auto Forwarding',
    icon: 'published_with_changes',
    iconColor: 'accent',
  },
  {
    id: 'notification',
    label: 'Manage Notification',
    icon: 'settings',
    iconColor: 'accent',
  },
  {
    id: 'manageGroup',
    label: 'Manage Group',
    svgIcon: 'object-multi-group',
    iconColor: 'accent',
  },
  {
    id: 'managePermission',
    label: 'Manage Permission',
    icon: 'group',
    iconColor: 'accent',
  },
  {
    id: 'unsubscribeFromItems',
    label: 'Revoke access',
    icon: 'unsubscribe',
    color: 'warn',
  },
  {
    id: 'removeItems',
    label: 'Delete all',
    icon: 'delete',
    color: 'warn',
  },
] as const satisfies readonly MultiAction[];

export type CustomerMultiActionId = (typeof customerMultiActions)[number]['id'];

export function getCustomerMultiAction(id: CustomerMultiActionId): MultiAction | undefined {
  return customerMultiActions.find((a) => a.id === id);
}
